import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AUTH } from "@/constants/testIds";
import { useSession } from "@/context/AuthContext";

export default function MagicCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { magicVerify } = useSession();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("This sign-in link is missing its token.");
      return;
    }
    (async () => {
      try {
        const data = await magicVerify(token);
        navigate(data.is_new ? "/onboarding" : "/dashboard", { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || "This sign-in link is invalid or has expired.");
      }
    })();
  }, [params, magicVerify, navigate]);

  return (
    <div data-testid={AUTH.magicCallbackRoot} className="relative flex min-h-screen w-full flex-col items-center justify-center bg-background text-foreground">
      <div aria-hidden="true" className="sema-grid pointer-events-none absolute inset-0 opacity-30" />
      <div className="relative z-10 flex flex-col items-center gap-4 px-6 text-center">
        {error ? (
          <>
            <ShieldAlert className="h-8 w-8 text-amber-400" />
            <p data-testid={AUTH.magicCallbackError} className="max-w-sm text-sm text-muted-foreground">{error}</p>
            <Link to="/login">
              <Button variant="outline" className="rounded-full border-border/80 text-xs uppercase tracking-[0.2em]">
                Back to sign in
              </Button>
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="h-7 w-7 animate-spin text-accent" />
            <p className="text-sm text-muted-foreground">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
